import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';

import { locator } from '../../testing/e2e-locator/locator';

export const ApplicationUpdatedModal = () => {
  const { t } = useTranslation();

  const reloadPageClicked = () => {
    window.location.reload();
  };

  return (
    <Modal data-testid={locator.components.applicationUpdateModal.root} open>
      <Box>
        <header
          data-testid={locator.components.applicationUpdateModal.header.root}
        >
          <h1 data-testid={locator.components.applicationUpdateModal.header.h1}>
            {t('applicationUpdatedModal.title')}
          </h1>
        </header>
        <div>
          <main
            data-testid={locator.components.applicationUpdateModal.main.root}
          >
            <p data-testid={locator.components.applicationUpdateModal.main.p}>
              {t('applicationUpdatedModal.content')}
            </p>
          </main>
          <footer
            data-testid={locator.components.applicationUpdateModal.footer.root}
          >
            <LoadingButton
              color="primary"
              data-testid={
                locator.components.applicationUpdateModal.footer
                  .reloadPageButton
              }
              endIcon={<></>}
              loading={false}
              loadingPosition="end"
              type="button"
              variant="contained"
              onClick={reloadPageClicked}
            >
              {t('applicationUpdatedModal.reloadPage')}
            </LoadingButton>
          </footer>
        </div>
      </Box>
    </Modal>
  );
};
